import { LitElement, html } from 'lit';

/**
 * Quote Financial Summary Component
 * Simple two-column display of financial totals: Total, GST, Grand Total
 * No calculations - displays data exactly as provided
 */
class QuoteFinancialSummary extends LitElement {
    static properties = {
        quoteData: { type: Object },
    };

    // Use Light DOM for Tailwind compatibility
    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.quoteData = null;
    }

    get subtotal() {
        return this.quoteData?.subtotal || this.quoteData?.subTotal || '$0.00';
    }

    get gstPercentage() {
        return this.quoteData?.pct || '15';
    }

    get gstAmount() {
        return this.quoteData?.gst || '$0.00';
    }

    get grandTotal() {
        return this.quoteData?.total || '$0.00';
    }

    render() {
        if (!this.quoteData) {
            return html``;
        }

        return html`
            <div
                class="stats stats-vertical lg:stats-horizontal shadow border-2 border-base-300 w-full"
            >
                <div class="stat">
                    <div class="stat-title">Total</div>
                    <div class="stat-value text-2xl">${this.subtotal}</div>
                </div>

                <div class="stat">
                    <div class="stat-title">GST (${this.gstPercentage}%)</div>
                    <div class="stat-value text-2xl">${this.gstAmount}</div>
                </div>

                <div class="stat bg-base-200">
                    <div class="stat-title text-lg font-bold">Grand Total</div>
                    <div class="stat-value text-3xl">${this.grandTotal}</div>
                </div>
            </div>
        `;
    }
}

customElements.define('quote-financial-summary', QuoteFinancialSummary);
